<template>
	<div class="flex items-center gap-6">
		<AtomLink
			v-if="facebook"
			title="Facebook"
			:url="facebook"
			new-tab
			class="bg-white text-gray-400 shadow-lg hover:text-blue-400 transition-colors rounded-full size-20 flex items-center justify-center"
		>
			<AtomFontAwesome
				icon="fa-facebook"
				library="fab"
				class="size-12"
			/>
		</AtomLink>
		<AtomLink
			v-if="instagram"
			title="Instagram"
			:url="instagram"
			new-tab
			class="bg-white text-gray-400 shadow-lg hover:text-red-400 transition-colors rounded-full size-20 flex items-center justify-center"
		>
			<AtomFontAwesome
				icon="fa-instagram"
				library="fab"
				class="size-12"
			/>
		</AtomLink>
		<AtomLink
			v-if="threads"
			title="Threads"
			:url="threads"
			new-tab
			class="bg-white text-gray-400 shadow-lg hover:text-black transition-colors rounded-full size-20 flex items-center justify-center"
		>
			<AtomFontAwesome
				icon="fa-threads"
				library="fab"
				class="size-12"
			/>
		</AtomLink>
		<AtomLink
			v-if="x"
			title="X"
			:url="x"
			new-tab
			class="bg-white text-gray-400 shadow-lg hover:text-black transition-colors rounded-full size-20 flex items-center justify-center"
		>
			<AtomFontAwesome
				icon="fa-x-twitter"
				library="fab"
				class="size-12"
			/>
		</AtomLink>
	</div>
</template>

<script lang="ts" setup>
defineProps<{
	facebook?: string;
	x?: string;
	threads?: string;
	instagram?: string;
}>();
</script>
